// import Vue from "vue";

import myUpload from "@/componentsMy/my-upload.vue";
export const setComponent = (vue) => {
  vue.component("my-upload", myUpload);
};
